export var mutations = {
    setUnits: function (state, units) {
        state.units = units;
    },
};
